import './Loader'

import Loader from 'packages/components/common/Loader'
import { configure as configureLazyPage } from 'packages/core/hoc/lazyPage'
import { withLayout } from 'app/view/Layout'

configureLazyPage({ delay: 200, pageLoader: withLayout()(Loader) })
